import React, { useContext, useEffect, useState } from 'react'
import { EventMetaContext } from '../../SingleEvent'
import DetailsBox from '../../../../../components/Cards/DetailsBox'
import BigModal from '../../../../../components/Modals/BigModal'
import VehicleAddPopup from './VehicleAddPopup'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
//@MUI
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'
import Delete from '@mui/icons-material/Delete'
import ExpandMore from '@mui/icons-material/ExpandMore'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import API from '../../../../../services/API'
import moment from 'moment'
import { LinearProgress, Stack, Typography } from '@mui/material'

const VehiclesInvolved = () => {
  const [openAddNew, setOpenAddNew] = useState(false)
  const { loadEvent, eventMeta } = useContext(EventMetaContext)
  const [accordionOpen, setAccordionOpen] = useState(false)
  const [vehicles, setVehicles] = useState([])
  const [loading, setLoading] = useState(false)

  const loadVehicles = () => {
    setLoading(true)
    setOpenAddNew(false)
    API.post('/fleet/getvehiclesdeployed', {
      linkedEvent: eventMeta._id,
    })
      .then((res) => {
        if (res.status === 200) {
          setVehicles(res.data)
          if (res.data?.length > 0) {
            setAccordionOpen(true)
          }
        }
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    loadVehicles()
  }, [])

  return (
    <Box
      sx={{
        border: '1px solid rgba(15, 23, 42, 0.08)',
        borderRadius: 2,
        overflow: 'hidden',
        bgcolor: 'background.paper',
      }}
    >
      {loading && <LinearProgress />}
      <Accordion disableGutters expanded={accordionOpen}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          sx={{ display: 'flex' }}
          onClick={() => setAccordionOpen(!accordionOpen)}
        >
          <Stack
            direction="row"
            alignItems="center"
            width="100%"
            justifyContent="space-between"
          >
            <Typography variant="title3">Vehicles</Typography>
            <IconButton
              size="small"
              color="primary"
              onClick={(e) => {
                e.stopPropagation()
                setOpenAddNew(true)
              }}
            >
              <Tooltip title="Add a Vehicle">
                <AddIcon />
              </Tooltip>
            </IconButton>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <CustomDataGrid
            maxHeight={300}
            rows={vehicles}
            slots={{
              toolbar: () => null,
              footer: () => null,
            }}
            hideToolbar
            disableRowSelectionOnClick
            getRowId={(params) => params._id}
            columns={[
              {
                field: 'callSign',
                headerName: 'Call Sign',
                minWidth: 200,
                valueGetter: (value, row) => row.vehicle.callSign,
              },
              {
                field: 'driverTo',
                headerName: 'Driver To',
                minWidth: 150,
                valueGetter: (value, row) =>
                  row?.driverTo &&
                  row?.driverTo?.firstName + ' ' + row?.driverTo?.lastName,
                flex: 1,
              },
              {
                field: 'driverFrom',
                headerName: 'Driver From',
                minWidth: 150,
                valueGetter: (value, row) =>
                  row.driverFrom &&
                  row?.driverFrom?.firstName + ' ' + row?.driverFrom?.lastName,
                flex: 1,
              },
              {
                field: 'start',
                headerName: 'Booked From',
                renderCell: ({ value }) => moment(value).format('Do MMM HH:mm'),
                minWidth: 150,
                headerAlign: 'center',
                align: 'center',
              },
              {
                field: 'end',
                headerName: 'Booked Until',
                renderCell: ({ value }) => moment(value).format('Do MMM HH:mm'),
                minWidth: 150,
                headerAlign: 'center',
                align: 'center',
              },
              {
                field: 'delete',
                headerName: '',
                renderCell: ({ row }) => (
                  <IconButton
                    onClick={() => {
                      API.delete(`/fleet/vehicleassignment/${row._id}`).then(
                        (res) => {
                          if (res.status === 200) {
                            loadEvent()
                          } else {
                            console.log('res.status', res.status)
                          }
                        },
                      )
                    }}
                  >
                    <Delete color="error" />
                  </IconButton>
                ),
                align: 'right',
                minWidth: 100,
              },
            ]}
          />
        </AccordionDetails>
      </Accordion>
      <BigModal open={openAddNew} onClose={() => setOpenAddNew(false)}>
        <VehicleAddPopup
          eventStart={eventMeta.startDate}
          eventEnd={eventMeta.endDate}
          loadVehicles={loadVehicles}
        />
      </BigModal>
    </Box>
  )
}

export default React.memo(VehiclesInvolved)
